import DataService from '@/service/DataService'

const state = {
  status: {},
  geraetetypen: []
}

const getters = {
  geraetetypenStatus: (state) => state.status,
  geraetetypen: (state) => state.geraetetypen
};

const actions = {
  // GET
  fetchGeraetetypen( { commit }) {
    commit('GETGERAETETYPENREQUEST')

    return DataService.getGeraetetypen()
      .then(res => {
        commit('GETGERAETETYPENSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETGERAETETYPENFAILURE', err)
      })
  },

  // POST
  addGeraetetyp({commit}, geraetetyp) {
    commit('ADDGERAETETYPENREQUEST')

    return DataService.createGeraetetyp(geraetetyp)
    .then(res => {
      commit('ADDGERAETETYPENSUCCESS', res.data)
    })
    .catch(err => {
      commit('ADDGERAETETYPENFAILURE', err)
    })
  },

  // DELETE
  removeGeraetetyp({commit}, geraetetypId) {
    commit('DELETEGERAETETYPENREQUEST')

    return DataService.deleteGeraetetyp(geraetetypId)
    .then(() => {
      commit('DELETEGERAETETYPENSUCCESS', geraetetypId)
    })
    .catch(err => {
      commit('DELETEGERAETETYPENFAILURE', err)
    })
  }
};

const mutations = {
  GETGERAETETYPENREQUEST: (state) => {state.status = { gettingGeratetypen: true }},
  GETGERAETETYPENSUCCESS: (state, res) => {
    state.status = {}
    state.geraetetypen = res
  },
  GETGERAETETYPENFAILURE: (state, err) => {state.status = {errMsg: err}},
  ADDGERAETETYPENREQUEST: (state) => {state.status = { creatingGeratetypen: true }},
  ADDGERAETETYPENSUCCESS: (state, res) => {
    state.status = {}
    state.geraetetypen.push(res)
  },
  ADDGERAETETYPENFAILURE: (state, err) => {state.status = {errMsg: err}},
  DELETEGERAETETYPENREQUEST: (state) => {state.status = { deletingGeratetypen: true }},
  DELETEGERAETETYPENSUCCESS: (state, res) => {
    state.status = {}

    let index = state.geraetetypen.findIndex(x => x.id == res)
    state.geraetetypen.splice(index, 1)
  },
  DELETEGERAETETYPENFAILURE: (state, err) => {state.status = {errMsg: err}},
};

export default {
  state,
  getters,
  actions,
  mutations
}